module.exports = __webpack_public_path__ + "img/Sib_Mus_2kl.17b5b3dd.jpg";